
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pupils/lessons/[lessonSlug]/overview",
      function () {
        return require("private-next-pages/pupils/lessons/[lessonSlug]/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pupils/lessons/[lessonSlug]/overview"])
      });
    }
  